import { render, staticRenderFns } from "./ConfigurarDetalleForm.vue?vue&type=template&id=1c4a902e&"
import script from "./ConfigurarDetalleForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarDetalleForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarDetalleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c4a902e', component.options)
    } else {
      api.reload('1c4a902e', component.options)
    }
    module.hot.accept("./ConfigurarDetalleForm.vue?vue&type=template&id=1c4a902e&", function () {
      api.rerender('1c4a902e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/ConfigurarDetalleForm.vue"
export default component.exports